<template>
  <b-container>
    <span v-if="!logo_creator_only">
      <h4 class="mt-4">Site logos</h4>
      <p class='card-description'>Upload your own or use the logo creator.</p>
      <b-card>
        <b-form-group label="Logo image" label-cols="4">
          <div v-if="site.logo.image">
            <img height="48" :src="site.logo.image" class="mr-2"/>
            <b-button variant="danger" @click="site.logo.image = null">Remove image</b-button>
          </div>
          <ImageSearch v-else :type="['upload']" classProp="btn btn-secondary" :action="url => {this.site.logo.image = url; this.update_logo()}" />
        </b-form-group>

        <b-form-group label="Favicon image" label-cols="4">
          <div v-if="site.logo.favicon" >
            <img height="48" :src="site.logo.favicon" class="mr-2"/>
            <b-button variant="danger" @click="site.logo.favicon = null">Remove image</b-button>
          </div>
          <ImageSearch v-else :type="['upload']" classProp="btn btn-secondary" :action="url => {this.site.logo.favicon = url; this.update_logo()}" :is_small="true"/>
        </b-form-group>
      </b-card>

      <h4 class="mt-4">Logo creator</h4>
      <p class='card-description'>Create a logo and favicon using your sites colours and fonts. Logo icon is used as a favicon.</p>
    </span>
    <b-card :style="`background-color: ${site.colour.primary_background}`">
      <div class="logo-container" ref="logo">
        <!-- :style="{width: '50px', height: '50px', backgroundColor: 'red'}"  -->
        <b-row>
          <!-- <div v-if="this.site.logo.icon" class="logo-icon" :style="`margin-right: 10px; display: inline-block; width: 48px; height: 48px; background-color: ${site.logo.icon_colour}; -webkit-mask: url(/image-proxy?url=${encodeURIComponent(site.logo.icon)}) no-repeat center / contain;`"></div> -->
          <!-- <img  :src="``" /> -->
          <span :style="`display: inline-block; font-family: ${site.style.title_font}; font-weight: ${site.style.title_weight}; color: ${site.logo.text_colour}; font-size: 3em;`">{{site.logo.text}}</span>
        </b-row>
      </div>

      <img :src="output">
    </b-card>

    <b-card class="mt-4">
      <b-form-group label="Text:" label-cols="4">
        <b-form-input v-model="site.logo.text"></b-form-input>
      </b-form-group>

      <b-form-group label="Logo text colour:" label-cols="4">
        <b-form-input type="color" v-model="site.logo.text_colour"></b-form-input>
      </b-form-group>

      <b-form-group label="Logo Icon:" label-cols="4">
        <b-button v-if="site.logo.icon" variant="danger" @click="site.logo.icon = null">Remove icon</b-button>
        <ImageSearch v-else :type="['upload', 'fa_icon']" classProp="btn btn-secondary" :action="url => {this.site.logo.icon = url}" :is_small="true"/>
      </b-form-group>

      <!-- <b-form-group label="Icon position:" label-cols="4">
        <b-form-input v-model="site.logo.icon_position" :options="['left', 'right', 'top', 'bottom']"></b-form-input>
      </b-form-group> -->

      <b-form-group label="Icon colour:" label-cols="4">
        <b-form-input type="color" v-model="site.logo.icon_colour"></b-form-input>
      </b-form-group>

      <LoadingButton @click="update_custom_logo" :loading="uploading">Save logo</LoadingButton>
    </b-card>

    <div ref="canvas_container"></div>

  </b-container>
</template>

<script>

import ImageSearch from '@/components/ImageSearch'
import { db, storage, serverTimestamp, FieldValue } from '@/main.js'
import html2canvas from 'html2canvas'

export default {
  name: 'logo',
  props: ['profile', 'site', 'logo_creator_only'],
  components: {ImageSearch},
  data() {
    return {
      output: '',
      uploading: false,
      url: 'https://storage.googleapis.com/kaizen-80c12.appspot.com/icons/regular/alarm-clock.svg'
    }
  },
  methods: {
    async update_custom_logo() {
      this.uploading = true
      let canvas = await this.$html2canvas(this.$refs.logo, {scale: 3, allowTaint: false, allowCORS: true, backgroundColor: "rgba(255,255,255,0)", removeContainer: true})
      // document.body.appendChild(canvas)
      this.$refs.canvas_container.appendChild(canvas)
      let data_url = canvas.toDataURL("image/png")
      this.$refs.canvas_container.innerHTML = ''

      data_url = "data:" + data_url

      // var link = document.createElement("a")
      // link.download = "logo.png"
      // link.href = data_url
      // link.click()

      let id = db.collection('random').doc().id
      let snap = await storage.ref().child(`media/${id}.png`).putString(data_url, 'data_url', {'cacheControl': 'max-age=2628000, public'})
      let selected_image_url = `https://storage.googleapis.com/${this.config.firebase_config.storageBucket}/media/${id}.png` // await snap.ref.getDownloadURL()

      this.site.logo.image = selected_image_url

      if (this.site.logo.icon) {
        this.site.logo.favicon = this.site.logo.icon
      }

      await this.update_logo()
      this.uploading = false
    },
    async update_logo() {
      await db.collection('site').doc(this.site.id).update({logo: this.site.logo})
      await db.collection('deploy_queue').doc(this.site.id).set({updated: serverTimestamp(), update_count: FieldValue.increment(1)}, {merge: true})
    }
  },
}
</script>

<style scoped>

.logo-icon {
  /* -webkit-mask: url(https://storage.googleapis.com/kaizen-80c12.appspot.com/icons/regular/alarm-clock.svg) no-repeat center / contain; */
}

.logo-container {
  margin: auto;
  padding: 4px;
  display: inline-block;
}

.logo-container img {
  float: left;
  height: 48px;
}

.logo-container h1 {
  padding-left: 1.3em;
}
</style>
